import React, { useEffect, useRef, useState } from "react";
import { Check, Loader2, Volume2 } from "lucide-react";
import { toast } from "sonner";
import { errMsg } from "@/lib/residentApi";
import { showApi } from "./showKit";

const DESC = { coral: "Warm and friendly", sage: "Calm and steady", alloy: "Neutral and even", nova: "Bright and upbeat", shimmer: "Soft and gentle" };

/** Pick the narrator for the whole film; each voice has a short preview. */
export default function VoicePicker({ show, onChanged }) {
  const [busy, setBusy] = useState(null);
  const audio = useRef(null);
  useEffect(() => () => audio.current?.pause(), []);
  const preview = async (v) => {
    audio.current?.pause();
    setBusy(v);
    try { const u = await showApi.sample(v); audio.current = new Audio(u); audio.current.play().catch(() => {}); } catch (e) { toast.error(errMsg(e)); }
    setBusy(null);
  };
  const pick = (v) => showApi.setVoice(v).then(() => { toast.success(`Narrator set to ${v[0].toUpperCase() + v.slice(1)} · click Prepare narration to record it`); onChanged(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="space-y-2" data-testid="showcase-voices">
      <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-nex-gold">Narrator voice · Platform Showcase only</div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
        {show.voices.map((v) => {
          const on = v === show.voice_key;
          return (
            <div key={v} data-testid={`showcase-voice-${v}`} className={`border p-2.5 ${on ? "border-nex-gold bg-nex-gold/10" : "border-white/10"}`}>
              <button type="button" onClick={() => !on && pick(v)} data-testid={`showcase-voice-pick-${v}`} className="w-full text-left">
                <span className="flex items-center gap-1 text-sm text-nex-silver font-semibold capitalize">{on && <Check className="h-3.5 w-3.5 text-nex-gold" />}{v}</span>
                <span className="block text-[11px] text-nex-muted">{DESC[v]}</span>
              </button>
              <button type="button" onClick={() => preview(v)} disabled={busy === v} data-testid={`showcase-voice-preview-${v}`} className="mt-2 inline-flex items-center gap-1 text-[11px] text-nex-gold hover:underline disabled:opacity-60">
                {busy === v ? <Loader2 className="h-3 w-3 animate-spin" /> : <Volume2 className="h-3 w-3" />} Preview
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
